module.exports = __webpack_public_path__ + "static/media/172.992028fb.webp";